var _rect, _path, _text, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridgioLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 34,
    height: 34,
    rx: 4,
    stroke: "white",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7V41M7 24H41",
    stroke: "white",
    strokeWidth: 2,
    opacity: 0.4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 32,
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 23,
    fontWeight: 700,
    textAnchor: "middle"
  }, "G")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 15,
    r: 3.5,
    fill: "#E5484D",
    stroke: "#17171F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridgioLogoWhite);
export default __webpack_public_path__ + "static/media/gridgio-logo-white.13dedf09c5647e631b9df194464d98be.svg";
export { ForwardRef as ReactComponent };